var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 17,
    viewBox: "0 0 39 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99981 1C5.79272 1.00896 6.5507 1.33492 7.11144 1.90809C7.67219 2.48127 7.99114 3.2561 8 4.06669C8 5.79973 6.56533 7 5.00019 7C4.20727 6.99104 3.4493 6.66508 2.88856 6.09191C2.32781 5.51873 2.00886 4.7439 2 3.93331C2 2.20008 3.43467 1 4.99981 1Z",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13C1 11.6739 1.52678 10.4021 2.46447 9.46447C3.40215 8.52678 4.67392 8 6 8C7.32608 8 8.59785 8.52678 9.53553 9.46447C10.4732 10.4021 11 11.6739 11 13",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.cf058c89afb7f912a6701021db026ff4.svg";
export { ForwardRef as ReactComponent };